import { useCallback, useRef, useState } from 'react';
export function usePermissionOverlay() {
    const [showPermissionOverlay, setShowPermissionOverlay] = useState(false);
    const resolveRef = useRef(undefined);
    const permissionOverlayOnClick = useCallback(() => {
        if (resolveRef.current) {
            resolveRef.current();
        }
    }, []);
    const onPermissionDefault = useCallback(async () => {
        setShowPermissionOverlay(true);
        await new Promise((resolve) => {
            resolveRef.current = resolve;
        });
    }, []);
    const onPermissionGranted = useCallback(() => {
        setShowPermissionOverlay(false);
        return Promise.resolve();
    }, []);
    const onPermissionDenied = useCallback(() => {
        setShowPermissionOverlay(false);
        return Promise.resolve();
    }, []);
    return {
        showPermissionOverlay,
        permissionOverlayOnClick,
        onPermissionDefault,
        onPermissionGranted,
        onPermissionDenied,
    };
}
